module.exports = __webpack_public_path__ + "img/notifications-black-24dp.49f01327.svg";